module.exports = __webpack_public_path__ + "static/media/landing-image.e8c24923.png";